import axios from 'axios'

const DashboardService = {
  async getStatistics (params = {}) {
    return axios.get('lo/dashboard', { params })
  }
}

export default DashboardService
